<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <section>
        <div class="fireworks_head">
          <p>{{datas.business.name}}</p>
          <p class="fsWave"><img width="100%" height="35px" src="../../static/images/Normal09/wave.png"></p>
        </div>

        <!-- 产品信息 -->
        <section class="fsBox">
          <div class="fsNav" value="1">
            <a class="ui-link"></a>
            <a class="ui-link">产品基本信息</a>
          </div>
          <div class="fsBoxContent">
            <viewer @inited="inited" ref="viewer">
              <p v-if="datas.product.img"><img class="showImg" :src="datas.product.img"></p>
            </viewer>
            <ul class="fs_p">
              <li v-if="datas.prod_name_is_show == 1">产品名称：{{datas.product.name}}</li>
              <li v-if="datas.product.period && datas.prod_name_is_show == 1">保 质 期：{{datas.product.period}}</li>
              <li v-if="datas.product.attribute" v-for="val in datas.product.attribute" v-text="val.key+'：'+val.value"></li>
              <li v-if="code !== 'AT9MJOIUL2S2175LHU'">首次扫码时间：{{datas.scan_first_time}}</li>
              <li v-if="datas.product.introduce && datas.prod_name_is_show == 1">产品描述：{{datas.product.introduce}}</li>
            </ul>
          </div>
        </section>
        <!-- 产品信息 -->


        <!-- 生产流程演示 -->
        <section class="fsBox" v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
          <div class="fsNav" value="1">
            <a class="ui-link"></a>
            <a class="ui-link">演示溯源信息</a>
          </div>
          <div class="TtyWire_two">
            <div>
              <ul>
                <li v-for="(item,index) in datas.process_demo" v-bind:key="index">
                  <p>{{item.name}}</p>
                  <i></i>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!-- 生产流程演示 -->
        
        <!-- 生产流程 -->
        <section class="fsBox" v-if="datas.process && datas.process_is_show == 1">
          <div class="fsNav" value="1">
            <a class="ui-link"></a>
            <a class="ui-link">溯源信息</a>
          </div>
          <div class="TtyWire_two">
            <div>
              <ul>
                <li v-for="(item,index) in datas.process" v-bind:key="index">
                  <p>{{item.name}}</p>
                  <p>{{item.date.substring(0,10)}}</p>
                  <i></i>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!-- 生产流程 -->

        <!-- 经销商流程 -->
        <section class="fsBox" v-if="datas.business.rootid != 100010094 && datas.dealer && datas.dealer_is_show == 1">
          <div class="fsNav" value="1">
            <a class="ui-link"></a>
            <a class="ui-link">物流信息</a>
          </div>
          <div class="TtyWire_two">
            <div>
              <ul>
                <li v-for="(item,index) in datas.dealer" v-bind:key="index">
                  <p>{{item.name}}</p>
                  <p>{{item.date.substring(0,10)}}</p>
                  <i></i>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <!-- 经销商流程 -->

        <!-- 自定义栏目 -->
        <viewer @inited="inited" ref="viewer">
          <div class="chickenTraceBlock" v-if="datas.ref && datas.ref_is_show == 1" v-for="(item,index) in datas.ref" v-bind:key="index" style="margin-bottom:10px;background-color: #FFD475;">
            <div class="fsNav" value="1" style="border-radius: 0px;"><a></a><a>{{ index.category }}</a></div>
            <div class="swiper-container dc_img" style="background-color: #FFD475;padding:7px 0px;">
              <div class="swiper-wrapper">
                <div v-for="(val,ix) in item.datas" v-bind:key="ix" :class="[{'swiper-slide':val.type == 1},{'_dc_img':val.type == 1}]">
                  <p v-if="val.type == 0" v-text="val.data" style="padding-top:6px;background-color: #000000;"></p>
                  <p v-else><img width="97%" class="showImg" :src="val.data"></p>
                </div>
              </div>
            </div>
          </div>
        </viewer>
        <!-- 自定义栏目 -->


        <!-- 自定义底部菜单 -->
        <div class="bottomNav_one" style="border-top:none;" v-if="datas.menu && datas.menu_is_show == 1">
          <ul v-if="datas.menu" v-for="(item,index) in datas.menu" v-bind:key="index" @click="ClickMenu(item)" style="background-color: #FFD475;border-bottom:1px solid #EBAA1D">
            <a data-ajax="false">
              <li style="background-color: #EBAA1D;" v-if="item.icon"><img style="width:80%;margin:0px auto;" :src="item.icon"></li>
              <li>
                <p style="color:#000">{{ item.name }}</p>
                <p style="color:#555">{{ item.describe }}</p>
              </li>
            </a>
          </ul>
          <ul v-if="!datas.menu" style="background-color: #FFD475;border-bottom:1px solid #EBAA1D">
            <a href="#" data-ajax="false">
              <li style="background-color: #EBAA1D;"><img style="width:80%;margin:0px auto;"
                  src="../../static/images/Normal09/nav_01.png"></li>
              <li>
                <p style="color:#000">官方网页</p>
                <p style="color:#555">企业官网点击即可进入~</p>
              </li>
            </a>
          </ul>
          <ul v-if="!datas.menu" style="background-color: #FFD475;border-bottom:1px solid #EBAA1D">
            <a href="#" data-ajax="false">
              <li style="background-color: #EBAA1D;"><img style="width:80%;margin:0px auto;"
                  src="../../static/images/Normal09/nav_04.png"></li>
              <li>
                <p style="color:#000">联系方式</p>
                <p style="color:#555">企业联系方式点击即可进入~</p>
              </li>
            </a>
          </ul>
        </div>
        <!-- 自定义底部菜单 -->

        <div style="text-align: center;line-height:40px;color:#EBAA1D" v-if="datas.business.linkphone">客服联系热线：<a style="color:#EBAA1D">{{datas.business.linkphone}}</a></div>
      </section>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal09',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      }
    }
  },
  created() {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#D4020F;font-size:16px;');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

  },
  updated() {
    if (self.datas.video) {
      self.initVideo();
    }
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.plan_id = response.data.meta.plan_id; //生码批次

          //自定义防伪查询语句
          if (datas.first_antifake_msg) {
            self.msg = datas.first_antifake_msg;
          }

          //自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          self.$nextTick(function () {
            new Swiper('.banner', {
              autoplay: {
                delay: 3000
              },
              autoHeight: true, //高度随内容变化
              loop: true, //可选选项，开启循环
            })

            //导航隐藏显示
            $('.fsNav').click(function(){
              $(this).next().toggle(300);
              var _fsVar = $(this).attr('value');
              if(_fsVar == 1){
                $(this).css({backgroundImage:'url(../../static/images/Normal09/_nabla.png)'});
                $(this).attr('value','2');
              }else{
                $(this).css({backgroundImage:'url(../../static/images/Normal09/nabla.png)'});
                $(this).attr('value','1');
              }
            });
            
          })
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.isShow = true;
            self.hintTxt = `您所查询的是 ${self.datas.business.name} 正品，当前查询次数为 ${json.meta.query_count} 次，感谢查询 ！`;
            if (json.meta.query_count === 1 && self.msg) {
              self.hintTxt = self.msg;
            }
          } else {
            self.isShow = false;
          }
        }).catch(function (error) {
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(VideoBox, {
        controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false,  //自动播放属性,muted:静音播放
        preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    }
  }
}
</script>

<style scoped>
.fireworks_head {
  text-align: center;
  color: #D4020F;
  width: 100%;
  position: relative;
  width: 100%;
  height: 80px;
}

.fireworks_head p:first-child {
  height: 50px;
  position: absolute;
  line-height: 50px;
  top: 0px;
  left: 0px;
  font-size: 1.2em;
  width: 100%;
  z-index: 99;
  background-color: #fbc143;
}

.fsWave {
  position: absolute;
  width: 100%;
  top: 38px;
  left: 0px;
  z-index: 98;
}

.fsBox {
  width: 95%;
  margin: 0px auto;
  margin-bottom: 20px;
  box-shadow: 5px 5px 5px rgba(9, 9, 9, .2);
}

.fsNav {
  overflow: hidden;
  height: 45px;
  line-height: 45px;
  background: url(../../static/images/Normal09/nabla.png) #fbc143;
  background-repeat: no-repeat;
  background-size: 17px;
  background-position: 95% 50%;
  font-size: 1em;
  cursor: pointer;
  border-bottom: 1px solid #ebaa1d;
  transition: 0.3s;
  border-radius: 5px 5px 0px 0px;
}

.fsNav a {
  display: block;
  float: left;
}

.fsNav a:first-child {
  width: 5px;
  height: 18px;
  background-color: #f60;
  border-radius: 5px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 14px;
}

.fsBoxContent {
  background-color: #FFD475;
  overflow: hidden;
  padding: 0px 3%;
  border-radius: 0px 0px 5px 5px;
}

.fsBoxContent img {
  width: 100%;
  margin-top: 8px;
}

.fs_p {
  padding-top: 10px;
  padding-bottom: 15px;
}

.fs_p li {
  font-size: 0.95em;
  color: #333;
  padding: 4px 0px;
}

/* 溯源样式 */
.TtyWire_two {
  background-color: #FFD475;
}

.TtyWire_two ul {
  border-left: 2px solid #FBC143;
}

.TtyWire_two li {
  border-bottom: 1px solid #FBC143;
}

.TtyWire_two li i {
  background-color: #FBC143;
}

.TtyWire_two li p {
  padding: 3px 0px;
  color: #000;
}

.TtyWire_two li p:nth-child(2) {
  font-size: 0.95em;
  color: #555;
}

.TtyWire_two li:first-child i {
  border: 3px solid #EBAA1D;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal09.vue